export default __webpack_public_path__ + "static/media/main-onlydrums.f5b7b0b0.mp3";